import React, { useContext, useEffect, useState } from 'react'
import { Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { AuthContext } from '../../../App/App';
import { MessageContext } from './Message';
import { ContentBodyContext } from '../MainContent';
import axios from 'axios'
import swal from 'sweetalert';
import jwt from 'jwt-decode'


function ModalNewMessage() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext);
    const { stateMessage, dispatchMessage } = useContext(MessageContext);

    const handleCancel = () => {
        setdataForm(initialDataForm)
        setworkunit([])
        dispatchMessage({
            type: 'NEW_CHAT',
            modal: false
        })
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        if (dataForm.category != '' && dataForm.workunit != '' && dataForm.message != '' && dataForm.errFile === null) {
            sendMessage()
        } else {
            setdataForm({
                ...dataForm,
                errWorkunit: dataForm.workunit == '' ? 'Please select work unit.' : null,
                errCategory: dataForm.category == '' ? 'Please select message category.' : null,
                errMessage: dataForm.message == '' ? 'Please type your message.' : null
            })
        }

    }
    const handleMessageInput = (event) => {
        setdataForm({
            ...dataForm,
            message: event.target.value,
            errMessage: (event.target.value === '' ? 'Please type your message.' : null)
        })
    }
    const handleAttachFileChange = (event) => {
        event.preventDefault();
        if (event.target.files[0] !== undefined) {
            setdataForm({
                ...dataForm,
                file: event.target.files[0],
                errFile: event.target.files[0].size > (2 * 1048576) ? 'Maximal attachment is 2MB.' : null
            })
        }
    }
    const handleChangeOption = (event) => {
        let valid = true
        if (event.target.name === 'category') {
            valid = stateMessage.prevChat.length === 0 ? true : (stateMessage.prevChat.find(chat => (chat.workunit.id == dataForm.workunit && chat.category.id == event.target.value))) ? (stateMessage.prevChat.find(chat => (chat.workunit.id == dataForm.workunit && chat.category.id == event.target.value))) : true
        }
        setdataForm({
            ...dataForm,
            [event.target.name]: (valid === true) ? event.target.value : '',
            errCategory: (event.target.name === 'category') ? (event.target.value === '' ? 'Please select category.' : (valid === true) ? null : 'You still have questions in this category.') : dataForm.errCategory,
            errWorkunit: (event.target.name === 'workunit') ? (event.target.value === '' ? 'Please select work unit.' : null) : dataForm.errWorkunit,
            errMessage: (event.target.value === '') ? dataForm.errMessage : null
        })
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(/[:;,]/));
        reader.onerror = error => reject(error);
    });

    const sendMessage = async () => {
        setdataForm({
            ...dataForm,
            isSubmitting: true
        })
        let file = null
        if (dataForm.file != null) file = await toBase64(dataForm.file)
        const jwtHelpdesk = jwt(localStorage.getItem('token-helpdesk-umy'))
        await stateContentBody.socket.emit(`helpdesk-chat`, {
            id: jwtHelpdesk.id,
            token: localStorage.getItem('token-helpdesk-umy'),
            action: 'new-list-message',
            data: {
                username: (jwtHelpdesk.role_id == 'student' || jwtHelpdesk.role_id == 'staff') ? jwtHelpdesk.user : jwtHelpdesk.status,
                message: dataForm.message,
                parent_chat: null,
                chat_type: { sender: 'user', type: jwtHelpdesk.role_id == 'student' ? `student` : `staff` },
                work_unit: workunit.find(wu => wu.id == dataForm.workunit).id,
                file: dataForm.file != null ? file[3] : file,
                mimetype: dataForm.file != null ? file[1] : file,
                category: dataForm.category,
                profile: {
                    status: jwtHelpdesk.role_id == 'student' || jwtHelpdesk.role_id == 'staff' ? jwtHelpdesk.role_id : 'admin',
                    id: jwtHelpdesk.id
                }
            }
        })
        settempDataForm({ ...tempDataForm, final: dataForm })
    }

    const getWorkunit = () => {
        //get work unit
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.get('/api/v1/helpdesk/message/workunits', config)
            .then(async res => {
                setworkunit(res.data.data)
                settempDataForm({ ...tempDataForm, workunit: res.data.data })
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again!!!'
                        })
                    } else if (err.response.data.message) {
                        swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const getCategory = () => {
        // get category
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.get(`/api/v1/helpdesk/message/category/${dataForm.workunit}`, config)
            .then(async res => {
                if (res.data.data.length <= 0) {
                    setcategory([])
                    swal("Warning!", "Message category is not available, please contact the workunit directly!", "warning", {
                        button: "OK",
                    });
                } else {
                    setcategory(res.data.data)
                    settempDataForm({ ...tempDataForm, category: res.data.data })
                }
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again!!!'
                        })
                    } else if (err.response.data.message) {
                        swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const [tempDataForm, settempDataForm] = useState({ workunit: null, category: null, final: null })
    const [tempNewData, settempNewData] = useState(null)

    const initialDataForm = {
        workunit: '',
        errWorkunit: null,
        category: '',
        errCategory: null,
        message: '',
        errMessage: null,
        file: null,
        errFile: null,
        isSubmitting: false
    }
    const [dataForm, setdataForm] = useState(initialDataForm)

    const [workunit, setworkunit] = useState([])
    const [category, setcategory] = useState([])

    const [renderModal, setrenderModal] = useState(<Fragment />)

    useEffect(() => {
        if (stateMessage.modal && workunit.length <= 0) getWorkunit()
    }, [stateMessage.modal])

    useEffect(() => {
        if (dataForm.workunit !== '') getCategory()
        else {
            setdataForm({
                ...dataForm,
                category: '',
            })
            setcategory([])
        }
    }, [dataForm.workunit])

    useEffect(() => {
        if (stateMessage.trigger.message === "helpdesk-chat" && stateMessage.trigger.action.name === 'new-list-message') {
            if (stateMessage.trigger.data === 'success') {
                settempNewData(stateMessage.trigger.action.data)
                handleCancel()
            } else if (stateMessage.trigger.data == 'error') {
                setdataForm({
                    ...dataForm,
                    isSubmitting: false
                })
            }
        } else if (stateMessage.trigger.data === 'success' && stateMessage.trigger.message === 'helpdesk-user-feedback-close' && stateMessage.prevChat.length > 0) {
            let prevChat = stateMessage.prevChat
            const index = stateMessage.prevChat.findIndex(chat => chat.id == stateMessage.trigger.action.data.chat_id)
            prevChat.splice(index, 1)
            dispatchMessage({
                type: 'PREV_CHAT',
                prevChat: prevChat
            })
        }
    }, [stateMessage.trigger])

    useEffect(() => {
        if (tempNewData != null && tempDataForm.final != null) {
            //reload filter body
            const workunit = tempDataForm.workunit.find(workunit => workunit.id == tempNewData.input.work_unit);
            const category = tempDataForm.category.find(category => category.id == tempNewData.input.category);
            const tempList = {
                action: "create",
                data: {
                    id: tempNewData.action.parent.id,
                    workunit: {
                        id: workunit.id,
                        name: workunit.name,
                        acronym: workunit.acronym
                    },
                    category: {
                        id: category.id,
                        name: category.name
                    },
                    status: {
                        id: 1,
                        name: "proses"
                    },
                    message: tempNewData.input.message,
                    attachment: tempDataForm.final.file == null ? null : tempDataForm.final.file.name,
                    time: tempNewData.input.time
                }
            }
            dispatchMessage({
                type: 'TEMP_LIST',
                tempListMessage: tempList,
            })
            settempNewData(null)
            settempDataForm(null)
        }
    }, [tempDataForm, tempNewData])

    useEffect(() => {
        if (stateMessage.modal) {
            setrenderModal(
                <Fragment>
                    <Modal className="modal-dialog modal-dialog-centered" isOpen={true} backdrop={'static'} keyboard={true}>
                        <ModalHeader toggle={handleCancel} charCode={<i className="fas fa-times-circle" style={{ fontSize: '20px' }}></i>}>
                            Start Chat
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group row">
                                <label htmlFor="workunit" className="col-form-label">Work unit</label>
                                <div className="input-group  has-validation">
                                    <select name="workunit" id="workunit" className={`form-control form-select  ${dataForm.errWorkunit != null ? 'is-invalid' : ''}`} required autoFocus aria-describedby="validateWorkunit" onChange={handleChangeOption} >
                                        <option value="">Choose Workunit</option>
                                        {workunit.length > 0
                                            ? workunit.map((data) => (
                                                <option key={data.id} value={data.id}>{data.name}</option>
                                            ))
                                            : <Fragment />}
                                    </select>
                                    <div id="validateWorkunit" className="invalid-feedback">
                                        <small>{dataForm.errWorkunit}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="category" className="col-form-label">Category</label>
                                <div className="input-group  has-validation">
                                    <select name="category" id="category" className={`form-control form-select  ${dataForm.errCategory != null ? 'is-invalid' : ''}`} required aria-describedby="validateCategory" onChange={handleChangeOption} >
                                        <option value="">Choose Category Message</option>
                                        {category.length > 0 ?
                                            category.map((data) => (
                                                <option key={data.id} value={data.id}>{data.name}</option>
                                            )) : <Fragment />}
                                    </select>
                                    <div id="validateCategory" className="invalid-feedback">
                                        <small>{dataForm.errCategory}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="file" className="col-form-label">File (Optional)</label>
                                <div className="input-group  has-validation">
                                    <input type="file" className={`form-control ${dataForm.errFile != null ? 'is-invalid' : ''}`} id="file" name="file" onChange={handleAttachFileChange} aria-describedby="validationInput" disabled={dataForm.workunit == '' || dataForm.category == '' ? true : false} />
                                    <div id="validationInput" className="invalid-feedback">
                                        <small>{dataForm.errFile}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="message" className="col-form-label">Message</label>
                                <div className="input-group  has-validation">
                                    <textarea className={`form-control ${dataForm.errMessage !== null ? 'is-invalid' : ''}`} value={dataForm.message} id="message" name="message" onChange={handleMessageInput} style={{ height: '150px' }} placeholder="Type your message here" aria-describedby="validationInput" disabled={dataForm.workunit === '' || dataForm.category === ''} />
                                </div>
                                {(dataForm.errMessage != null ? <small style={{ color: 'red', fontSize: '0.6em' }}>{dataForm.errMessage}</small> : <Fragment />)}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="success" onClick={handleSubmit} style={{ textTransform: 'capitalize' }} disabled={dataForm.isSubmitting || dataForm.workunit === '' || dataForm.category === '' || dataForm.message === ''}>{dataForm.isSubmitting ? '...Sending Message' : 'Send'} <i className={dataForm.isSubmitting ? 'fas fa-spinner fa-pulse' : "fas fa-paper-plane"}></i></Button>
                            <Button color="secondary" onClick={handleCancel} style={{ textTransform: 'capitalize' }}>Cancel</Button>
                        </ModalFooter>
                    </Modal>
                </Fragment>
            )
        } else {
            setrenderModal(<Fragment />)
        }
    }, [stateMessage.modal, dataForm, workunit, category])
    return (renderModal)
}

export default ModalNewMessage
